import React, { useState, useEffect } from 'react';

const CAMPAIGN_START = new Date('2026-06-01T00:00:00');
const CAMPAIGN_END = new Date('2026-08-31T23:59:59');
const DISMISS_KEY = 'campaign-popup-dismissed-summer-2026';

const CampaignPopup: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const now = new Date();
    if (now < CAMPAIGN_START || now > CAMPAIGN_END || localStorage.getItem(DISMISS_KEY)) return;
    const timer = setTimeout(() => setVisible(true), 2500);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    setVisible(false);
    localStorage.setItem(DISMISS_KEY, '1');
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-sm w-full animate-slide-up">
      <div className="bg-white rounded-lg shadow-2xl border border-gray-200 p-6 relative">
        <button onClick={dismiss} className="absolute top-2 right-3 text-gray-400 hover:text-gray-600 text-xl leading-none" aria-label="Stäng">×</button>
        <div className="mb-1">
          <span className="inline-block bg-green-100 text-green-700 text-xs font-semibold px-2 py-0.5 rounded-full uppercase tracking-wide">Kampanj</span>
        </div>
        <h3 className="text-lg font-bold text-[#0A4A7A] mt-2">Gratis hörseltest – begränsad tid!</h3>
        <p className="text-sm text-gray-600 mt-2">
          Upptäck hur din hörsel mår med ett snabbt och professionellt test – helt utan kostnad. Erbjudandet gäller t.o.m. 31/8.
        </p>
        <a
          href="https://www.bokadirekt.se/places/varmdo-horsel-134414"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 block w-full text-center bg-[#0A4A7A] text-white py-2.5 rounded font-semibold hover:bg-[#083d66] transition-colors"
        >
          Boka gratis hörseltest
        </a>
      </div>
    </div>
  );
};

export default CampaignPopup;
